import React from "react";
import homeStyle from "../../style/body/Home.module.css";

const Home = () => {
  return (
    <div className={`container ${homeStyle.home_container}`}>
      <div className={`row ${homeStyle.content_main_div}`}>
        <div className={` col-12 col-md-8 ${homeStyle.intro} `}>
          <h2 className={` ${homeStyle.intro_line}`}>
            <label className={`${homeStyle.text_align_justified}`}>
              Hi! I'm{" "}
              <label className={`${homeStyle.font_weight_600}`}>
                MD. MOSHIUL AZAM
              </label>
              ,
            </label>{" "}
            a{" "}
            <label className={`${homeStyle.pink} ${homeStyle.font_weight_600}`}>
              Software Engineer
            </label>{" "}
            and{" "}
            <label className={`${homeStyle.pink} ${homeStyle.font_weight_600}`}>
              Blockchain Researcher
            </label>
          </h2>
          <h6
            className={`${homeStyle.container_center} ${homeStyle.display_block}`}
          >
            <img
              className={`pr-8 ${homeStyle.pb_18} ${homeStyle.job_icon1}`}
              src="assets/icons/home-icons/jobHighlight.svg"
              alt="cuurent job icon"
            ></img>
            <div>
              <img
                className={`pr-8 ${homeStyle.pb_3} ${homeStyle.job_icon2}`}
                src="assets/icons/home-icons/jobHighlight.svg"
                alt="cuurent job icon"
              ></img>
              Currenty working at{" "}
              <b className={`${homeStyle.pink}`}>
                <a
                  className={`${homeStyle.text_decoration_none}`}
                  href="https://rootdevs.com"
                  target="_blank"
                >
                  ROOTDEVS.
                </a>
              </b>
              , Dhaka, Bangladesh
            </div>
          </h6>
        </div>
        <div className={`col-12 col-md-4 ${homeStyle.dp_container}`}>
          <img src="assets/images/DP.png" alt="Display Image"></img>
        </div>
      </div>
    </div>
  );
};

export default Home;
